import { AbstractControl, AsyncValidatorFn } from "@angular/forms";
import { map, of } from "rxjs";
import { EmployeeService } from "src/app/company/services/employee.service";
import { IBaseSearchRequest } from "src/app/core/models/base";

export function EmployeePhoneNumberValidator(employeeService: EmployeeService, currentEmployeeId?: string): AsyncValidatorFn {
    return  (control: AbstractControl) => {
        const value = (control.value || '').trim();

        // Skip validation if phone number is empty (optional field)
        if (!value) {
            return of(null);
        }

        const request : IBaseSearchRequest= {
            pageNumber:0,
            pageSize: 999999,
            advancedFilter:{
                logic: "and",
                filters: [
                    {
                        field: 'phoneNumber',
                        operator: 'eq',
                        value: control.value

                    }
                ]
            }
        }
        // check if form has yet been changed
        // prevent unessecary api call and inital error message
          return employeeService.getEmployees(request).pipe(
              map(response => {
                  const employees = response.data;

                    // Exclude current employee from duplicate check
                    const isDuplicate = employees.some(emp => emp.id !== currentEmployeeId);
                    return isDuplicate ? { phoneNumberExists: true } : null;
              })
          )
    }
}
